/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.CRM {

    @Serenity.Decorators.registerClass()
    export class TaskboardDialog extends NoboxEntityDialog<TaskboardRow, any> {
        protected getFormKey() { return TaskboardForm.formKey; }
        protected getIdProperty() { return TaskboardRow.idProperty; }
        protected getLocalTextPrefix() { return TaskboardRow.localTextPrefix; }
        protected getNameProperty() { return TaskboardRow.nameProperty; }
        protected getService() { return TaskboardService.baseUrl; }
        protected getDeletePermission() { return TaskboardRow.deletePermission; }
        protected getInsertPermission() { return TaskboardRow.insertPermission; }
        protected getUpdatePermission() { return TaskboardRow.updatePermission; }

        protected form = new TaskboardForm(this.idPrefix);
        public reloadBoard: () => void;
        constructor() {
            super();
            this.form.BoardList.change(e => {
                if (!Q.isEmptyOrNull(this.form.BoardList.value)) {
                    var arrListSaved = [];
                    var oldArray = this.form.BoardList.element.parent().find("ul.select2-choices").children("li.select2-search-choice").map(function () {
                        if ($(this).attr("data-id") != undefined) {
                            return $(this).attr("data-id") + "";
                        }
                    }).get();
                    var newArray = this.form.BoardList.value.split(",");
                    //var newArray = ['407670876676101', '405924637904901', '413335243427845', '405924582400005'];
                    //var oldArray = [
                    //    "413335243427845",
                    //    "405924637904901",
                    //    "407670876676101"
                    //];
                    arrListSaved = oldArray.filter(function (value) {
                        return newArray.includes(value);
                    }).sort(function (a, b) {
                        return oldArray.indexOf(a) - oldArray.indexOf(b);
                    });

                    newArray.forEach(function (value) {
                        if (!oldArray.includes(value)) {
                            arrListSaved.push(value);
                        }
                    });

                    arrListSaved.forEach((x, i) => {
                        this.form.BoardList.element.parent().find("ul.select2-choices").children("li.select2-search-choice").eq(i).attr("data-id", x);
                    });
                }
            });
            var $this = this;
            this.form.BoardList.element.parent().find("ul.select2-choices").bind("DOMSubtreeModified", () => {
                this.form.BoardList.element.parent().find("ul.select2-choices").children("li.select2-search-choice").each(function (i, items_list) {
                    setTimeout(() => {
                        if ($(this).attr("data-id") == undefined) {
                            var valueArr = $this.form.BoardList.value.split(",");
                            //console.log(valueArr[i], valueArr, "okes")
                            $(this).attr("data-id", valueArr[i])
                        }
                    }, 100)

                });
            });
        }
        protected save(callback) {

            this.form.BoardList.element.val(this.form.BoardList.element.parent().find("ul.select2-choices").children("li.select2-search-choice").map(function () {
                return $(this).attr("data-id") + "";
            }).get().toString());
            super.save(callback);
        }
        protected getSaveEntity() {
            var hasil = super.getSaveEntity();
            hasil.BoardListOri = Q.isEmptyOrNull(this.form.BoardListOri.value) ? [] : this.form.BoardListOri.value.split(",");
            return hasil;
        }
        protected afterLoadEntity(): void {
            super.afterLoadEntity();
            var self = this;
            if (this.isEditMode()) {
                if (this.get_entity().BoardListOri.length != null && this.get_entity().BoardListOri.length != 0) {

                    this.get_entity().BoardListOri.forEach(x => {
                        var el = $(`<li class="select2-search-choice" data-id="${x}"><div>${this.get_entity().BoardListEntity.find(z => z.ListId === x).ListNama}</div><a href="#" class="select2-search-choice-close" tabindex="-1"></a></li>`);
                        el.find(".select2-search-choice-close").on("click", function () {
                            var value = self.form.BoardList.element.val().split(",");
                            var index = value.indexOf(el.attr("data-id"));
                            value.splice(index, 1);
                            self.form.BoardList.element.val(value.toString());
                            el.remove();
                        });
                        this.form.BoardList.element.parent().find("ul.select2-choices").append(el);
                    });
                    this.form.BoardList.element.val(this.get_entity().BoardListOri.toString());
                    //Q.serviceCall({
                    //    url: "/Services/" + TasklistService.baseUrl + "/List",
                    //    request: {
                    //        Criteria: [["Id"], "in", [this.get_entity().BoardListOri]],
                    //        ColumnSelection: 1,
                    //        IncludeColumns: ["Id", "Nama"],
                    //    },
                    //    onSuccess: (res: any) => {
                    //        this.get_entity().BoardListOri.forEach(x => {
                    //            var el = $(`<li class="select2-search-choice" data-id="${x}"><div>${res.Entities.find(z => z.Id === x).Nama}</div><a href="#" class="select2-search-choice-close" tabindex="-1"></a></li>`);
                    //            el.find(".select2-search-choice-close").on("click", function () {
                    //                var value = self.form.BoardList.element.val().split(",");
                    //                var index = value.indexOf(el.attr("data-id"));
                    //                value.splice(index, 1);
                    //                self.form.BoardList.element.val(value.toString());
                    //                el.remove();
                    //            });
                    //            this.form.BoardList.element.parent().find("ul.select2-choices").append(el);
                    //        });
                    //        this.form.BoardList.element.val(this.get_entity().BoardListOri.toString());
                    //    }
                    //});
                }
            }
            this.sortableBoard();
        }

        sortableBoard() {

            var orderSortedPassageValues = () => {
                this.form.BoardList.element.parent().find("ul.select2-choices").children("li.select2-search-choice").each(function (i, obj) {
                    var element = $(this);
                    moveElementToEndOfParent(element)
                });
            };

            var moveElementToEndOfParent = function (element) {
                var parent = element.parent();

                element.detach();

                parent.append(element);
            };
            this.form.BoardList.element.parent().find("ul.select2-choices").sortable({
                containment: 'parent',
                cursor: "move",
                start: (event, ui) => {
                    //this.form.BoardList.element.parent().find("ul.select2-choices").unbind("DOMSubtreeModified");
                },
                stop: (event, ui) => {
                    //this.form.BoardList.element.parent().find("ul.select2-choices").unbind("DOMSubtreeModified");
                },
                update: (event, ui) => {
                    orderSortedPassageValues();
                }
            });
        }

        protected onSaveSuccess(response: Serenity.SaveResponse): void {
            this.reloadBoard();
        }
    }
}